/* eslint-disable react/display-name */
import React from 'react';
import { Subscribe } from 'unstated';

const withSubscribe = WrappedComponent => containers => props => (
  <Subscribe to={containers}>
    {(...args) => (
      <WrappedComponent subscribedContainers={args} {...props} />
    )}
  </Subscribe>
);

export default withSubscribe;
